import React from "react";
import {Button, Dialog, Heading, Modal, ModalOverlay} from "react-aria-components";
import {useModalStore} from "@store/ModalStore";
import "./AppModal.scss";
import {useProjectTranslations} from "@i18n/i18nUtils";

export function AppModal() {
    const {isOpen, config, close} = useModalStore();
    const {t} = useProjectTranslations();

    const tone = config?.tone ?? "neutral";
    const isDismissable = config?.isDismissable ?? true;
    const showCloseButton = config?.showCloseButton ?? true;
    const closeLabel = config?.closeLabel ?? t("close");

    const runAction = async (action: any, result: any) => {
        if (!action || action.disabled) return;
        await action.onPress?.();
        if ((action.autoClose ?? true) === true) close(result);
    };

    const content =
        typeof config?.content === "function"
            ? config.content()
            : config?.content;

    return (
        <ModalOverlay
            isOpen={isOpen}
            isDismissable={isDismissable}
            onOpenChange={(open) => {
                if (!open) {
                    if (!isDismissable) return;
                    close("dismiss");
                }
            }}
            className="appModalOverlay"
        >
            <Modal className={["appModal", config?.className ?? ""].join(" ").trim()}>
                <Dialog className="appModalDialog">
                    {({close: ariaClose}) => (
                        <>
                            <div className="appModalHeader">
                                <Heading slot="title" className={`appModalTitle tp-m bold appModalTitle--${tone}`}>
                                    {config?.title}
                                </Heading>

                                {showCloseButton ? (
                                    <Button
                                        className="appModalClose"
                                        onPress={() => {
                                            if (!isDismissable) return;
                                            ariaClose();
                                            close("dismiss");
                                        }}
                                        aria-label={closeLabel}
                                        isDisabled={!isDismissable}
                                    >
                                        {closeLabel} ✕
                                    </Button>
                                ) : null}
                            </div>

                            <div className="appModalBody">
                                {content ? <div className="appModalContent">{content}</div> : null}

                                {(config?.primaryAction || config?.secondaryAction) ? (
                                    <div className="appModalActions">
                                        {config?.secondaryAction ? (
                                            <Button
                                                className="cta cta--medium cta--secondary"
                                                onPress={() => runAction(config.secondaryAction, "secondary")}
                                                isDisabled={!!config.secondaryAction.disabled}
                                            >
                                                {config.secondaryAction.label}
                                            </Button>
                                        ) : null}

                                        {config?.primaryAction ? (
                                            <Button
                                                className="cta cta--medium"
                                                onPress={() => runAction(config.primaryAction, "primary")}
                                                isDisabled={!!config.primaryAction.disabled}
                                            >
                                                {config.primaryAction.label}
                                            </Button>
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>
                            {config?.footerMessage ? (
                                <div className="appModalFooter">
                                    {config.footerMessage}
                                </div>
                            ) : null}
                        </>
                    )}
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
}